<div [ngClass]="{'organization-width': !showEditMode}">

  <!-- ── Label / read-only display ─────────────────────────────────────── -->
  <div [ngClass]="{'is-hidden': showEditMode}">
    <div class="control">
      <span *ngIf="!currentOrganizationName">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
      <span *ngIf="currentOrganizationName" name="spnLabel">{{ currentOrganizationName }}</span>
    </div>
  </div>

  <!-- ── Edit / search input ────────────────────────────────────────────── -->
  <div [ngClass]="{'is-hidden': !showEditMode}">
    <p class="control no-right-margin" [ngClass]="controlClass">
      <input
        type="text"
        class="input is-small network-org-input"
        [placeholder]="getPlaceholder()"
        [formControl]="formControl"
        [matAutocomplete]="auto"
        [attr.readonly]="isReadonly ? true : null" />

      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayFn.bind(this)"
        [panelWidth]="380"
        autoActiveFirstOption>

        <mat-option
          *ngFor="let org of organizationOptions | async"
          [value]="org"
          (onSelectionChange)="handleSelectSuggestion($event)">
          <div class="network-org-item">
            <span class="network-org-ctep">{{ org.ctepId }}</span>
            <span class="network-org-sep"> | </span>
            <span class="network-org-name">{{ org.name }}</span>
            <span *ngIf="org.orgId" class="network-org-sep"> | </span>
            <span *ngIf="org.orgId" class="network-org-id">{{ org.orgId }}</span>
          </div>
        </mat-option>

      </mat-autocomplete>
    </p>
  </div>

</div>
